module.exports = __webpack_public_path__ + "static/img/text.cc56601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/text.png
// module id = md2n
// module chunks = 1